module.exports = __webpack_public_path__ + "static/media/nosmoking_sign.9b6d5fd9.png";